import React, { PureComponent } from "react";
import AppLoading from "../../App/AppLayout/containers/AppLoading";

class Loading extends PureComponent {
  render() {
    const { msg } = this.props;
    return <AppLoading show={true} transparent={true} msg={msg} />;
  }
}

export default Loading;
